export default __webpack_public_path__ + "static/media/LLhRskG.04a4e171.png";